<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" width="800px"
     :close-on-click-modal="false" :close-on-press-escape="false" :destroy-on-close="true" @close="close" @open="open">
      <div class="title-style" slot="title">
        <div class="dialog_title">选择需要对接的API接口</div>
        <div class="bd_bottom"></div>
      </div>
      <!-- <div class="search-input">
        <el-input placeholder="请输入..." style="width: 262px;margin-bottom: 10px" suffix-icon="el-icon-search" v-model="searchKey"></el-input>
      </div> -->
      <div class="tab-style">
        <div :class="['f_icon', leftTrue ? 'true_icon' : 'disabled_icon']" @click="leftClick"><i :class="['el-icon-arrow-left', 'icon-style', leftTrue ? 'true-style' : 'false-style']"></i></div>
        <div class="header-menu">
          <div
            class="header-menu-item"
            v-for="(item, index) in tabList"
            :key="index"
            :style="{'margin-left': index === 0 ? '0px': '60px'}"
            :class="{ active: activeIndex === item.value, active_font_color: activeIndex === item.value }"
            @click="tabClick(item.value)"
          >
            {{ item.label }}
          </div>
        </div>
        <div :class="['f_icon', rightTrue ? 'true_icon' : 'disabled_icon']" @click="rightClick"><i :class="['el-icon-arrow-right', 'icon-style', rightTrue ? 'true-style' : 'false-style']"></i></div>
      </div>
      <el-table class="table-style" border :data="tableList" style="max-height:400px;width: 100%;margin-top: 15px"
       @selection-change="handleSelectionChange">
        <el-table-column :selectable="selectHandler" type="selection" width="55"></el-table-column>
        <el-table-column prop="interfaceName" label="接口名称" width="150" align="center"></el-table-column>
        <el-table-column label="接口类型" width="100" align="center">
          <template slot-scope="{ row }">
            <span>{{apiType[row.interfaceType]}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="接口描述" align="center"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="add" :disabled="!selectData.length">添加到调试列表</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { RESPONSE_SUCCESS } from '@/constants'
export default {
  name: 'SelectApi',
  data() {
    return {
      dialogVisible: false,
      activeIndex: 1,
      tabList: [],
      tabAllList: [
        { label: '基础信息', value: 1 },
        { label: '订单服务', value: 2 },
        { label: '电子面单', value: 3 },
        { label: '物流轨迹', value: 4 },
        { label: '其它服务', value: 5 }
      ],
      tableList: [],
      searchKey: '',
      leftTrue: false,
      rightTrue: true,
      appId: '',
      apiType: { 0: '订阅类', 1: '注册类' },
      selectData: [],
      selectedList: []
    }
  },
  watch: {
    'activeIndex': {
      deep: true,
      handler(v) {
        if (v === this.tabAllList[0].value) {
          this.leftTrue = false
        } else {
          this.leftTrue = true
        }
        if (v === this.tabAllList[this.tabAllList.length - 1].value) {
          this.rightTrue = false
        } else {
          this.rightTrue = true
        }
      }
    }
  },
  methods: {
    selectHandler(row) {
      const temp = this.selectedList.find(v => v === row.id)
      if (temp) return false
      else return true
    },
    async getApiManagementList() {
      const formData = new FormData()
      formData.append('appId', this.appId)
      const { code, data } = await this.$API.managementList(formData)
      if (code === RESPONSE_SUCCESS) {
        if (data.debugList) {
          data.debugList.forEach(v => {
            this.selectedList.push(v.interfaceId)
          })
        }
        if (data.waitingList) {
          data.waitingList.forEach(v => {
            this.selectedList.push(v.interfaceId)
          })
        }
        if (data.completedList) {
          data.completedList.forEach(v => {
            this.selectedList.push(v.interfaceId)
          })
        }
        this.selectedList = Array.from(new Set(this.selectedList))
      }
    },
    handleSelectionChange(val) {
      if (!val.length) {
        this.selectData = []
      } else {
        this.selectData = val.map(v => v.id)
      }
    },
    async init(appId) {
      this.tabList = this.tabAllList.slice(0, 5)
      this.dialogVisible = true
      this.appId = appId
      await this.getApiList()
      this.getApiManagementList()
    },
    /**
     * @description 根据业务类型获取接口列表
     */
    async getApiList() {
      const { code, data, msg } = await this.$API.apiList({ serviceType: this.activeIndex, appId: this.appId })
      if (code === RESPONSE_SUCCESS) {
        this.tableList = data
        this.selectData = []
      } else {
        this.tableList = []
        this.selectData = []
        this.$message.error(msg)
      }
    },
    async add() {
      const { code, msg } = await this.$API.addInterface({ idList: this.selectData, appId: this.appId })
      if (code === RESPONSE_SUCCESS) {
        this.$message.success(msg)
        this.$emit('refreshTable')
        this.close()
      } else {
        this.$message.error(msg)
      }
    },
    open() {
      this.tabList = this.tabAllList.slice(0, 5)
      this.leftTrue = false
      this.rightTrue = true
      this.activeIndex = this.tabList[0].value
    },
    close() {
      this.searchKey = ''
      this.dialogVisible = false
      this.activeIndex = 1
      this.tableList = []
      this.selectData = []
      this.selectedList = []
    },
    tabClick(index) {
      this.activeIndex = index
      this.getApiList()
    },
    leftClick() {
      if (this.leftTrue) {
        if (this.activeIndex !== this.tabList[0].value) {
          const index = this.tabList.findIndex(v => v.value === this.activeIndex)
          this.activeIndex = this.tabList[index - 1].value
          this.getApiList()
        } else {
          if (this.activeIndex !== this.tabAllList[0].value) {
            this.tabList.splice(4, 1)
            const temp = this.tabAllList.findIndex(v => v.value === this.activeIndex)
            this.tabList.unshift(this.tabAllList[temp - 1])
            this.activeIndex = this.tabList[0].value
            this.getApiList()
          }
        }
      }
    },
    rightClick() {
      if (this.rightTrue) {
        if (this.activeIndex === this.tabList[4].value) {
          const temp = this.tabAllList.findIndex(v => v.value === this.activeIndex)
          if (temp !== this.tabAllList.length - 1) {
            this.tabList.splice(0, 1)
            this.tabList.push(this.tabAllList[temp + 1])
            this.activeIndex = this.tabList[4].value
            this.getApiList()
          }
        }
        if (this.activeIndex !== this.tabList[4].value) {
          const index = this.tabList.findIndex(v => v.value === this.activeIndex)
          this.activeIndex = this.tabList[index + 1].value
          this.getApiList()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.title-style {
  .dialog_title {
    padding: 20px 0 17px 40px;
    font-size: 20px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 700;
    text-align: left;
    color: #2b2b2b;
  }
  .bd_bottom {
    height: 1px;
    background: #d9d9d9;
    border-radius: 6px;
  }
}
::v-deep .el-input__inner {
  border-radius: 6px !important;
}
.tab-style {
  display: flex;
  align-items: center;
  .f_icon {
    width: 26px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    border-radius: 6px;
    .icon-style {
      font-size: 16px;
    }
  }
  .true_icon {
    border: 1px solid #E60000;
    .true-style {
      color: #E60000;
      cursor: pointer;
    }
  }
  .disabled_icon {
    border: 1px solid #d9d9d9;
    .false-style {
      cursor:not-allowed;
    }
  }
  .header-menu {
    margin: 0 auto;
    width: 600px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    overflow: hidden;
    .active_font_color {
      color: #E60000 !important;
    }
    .header-menu-item {
      display: inline-block;
      margin-left: 60px;
      cursor: pointer;
      position: relative;
      color: #2b2b2b;
      &.active:after {
        content: '';
        width: 30px;
        height: 4px;
        background: #E60000;
        border-radius: 2px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
::v-deep .el-dialog__header {
  padding: 0 !important;
}
::v-deep .el-dialog__footer {
  text-align: center;
}
::v-deep .el-dialog {
  border-radius: 6px;
}

::v-deep .el-table__body-wrapper {
  overflow-y: auto !important;
  max-height: 352px !important;
}
</style>
